import React from 'react';

function NewsCard(props) {
  return (
    <>
      <li className='cards_item'>
        <a
          className='cards_item_link'
          rel='noreferrer'
          target='_blank'
          href={props.newsUrl}
        >
          <figure
            className='cards_item_pic-wrap'
            data-category={props.newsLabel}
          >
            <img src={props.newsThumbnail} alt='' className='cards_item_img' />
          </figure>
          <div className='cards_item_info d-flex-col justify-content-between'>
            <p className='card_item_title'>{props.newsName}</p>
            <div className='d-flex-col'>
              <p className='cards_item_content text-gray'>
                {props.newsContent}
                {/* <span> see more...</span> */}
              </p>
              <p className='cards_item_more'>see more...</p>
            </div>
            <p className='cards_item_date'>{props.newsDate}</p>
          </div>
        </a>
      </li>
    </>
  );
}

export default NewsCard;
